<template>    
  <div class="content">
    <base-header class="pb-6 bg-gradient-info">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Rechnungen</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h3 class="mb-0">Rechnungen</h3>
            <p class="text-sm mb-0">
              Nachfolgend finden Sie alle von Ihnen an uns gestellten Rechnungen.
            </p>
          </template>
          <div>

                      <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Anzahl pro Seite" @change="handlePageSizeChange"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input v-model="searchQuery"
                            prepend-icon="fas fa-search"
                            placeholder="Suchen..." @input="searchInvoices">
                </base-input>
              </div>
            </b-col>


<div class="loader" v-if="loading"></div>


    <el-table class="table-responsive align-items-center table-flush table-striped"
              header-row-class-name="thead-light"
              :data="tutorials">
      <el-table-column label="Nummer"
                       min-width="200px"
                       prop="internal_id"
                       sortable>
                       </el-table-column>
      <el-table-column label="Status"
                       min-width="200px"
                       prop="aasm_state"
                       sortable>
                       </el-table-column>
      <el-table-column label="Zugehörig"
                       min-width="200px"
                       prop="internal_id"
                       sortable>
                       </el-table-column>
      <el-table-column label="Erstellt"
                       prop="created_at"
                       min-width="140px"
                       sortable>
                       </el-table-column>
      <el-table-column label="Rechnungsdatum"
                       prop="invoice_date"
                       min-width="140px"
                       sortable>
                        </el-table-column>

      <el-table-column label="Product"
                       min-width="200px"
                       prop="sum_net"
                       sortable>
      </el-table-column>

    </el-table>

</div>









        <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination v-model="page" :per-page="pageSize" :total="count" @change="handlePageChange"></base-pagination>
        </b-card-footer>

        </card>
      </div>
    </b-container>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { BasePagination } from '@/components';
import LightTable from "../Tables/RegularTables/LightTable";
import { TablePlugin } from 'bootstrap-vue'

export default {
    components: {
    BasePagination,
    RouteBreadCrumb,
    LightTable,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
    },
  data () {
    return {
      loading: false,
      search: '',
      invoices: [],
      currentInvoice: null,
      perPage: 1,
      currentPage: 1,
      tutorials: [],
      currentTutorial: null,
      currentIndex: -1,
      searchTitle: "",

      page: 1,
      count: 0,
      pageSize: 10,
      pageCount: 0,

      pageSizes: [3, 6, 9],

      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      searchedData: [],
    }
  },
  methods: {
    getRequestParams(searchTitle, page, pageSize) {
      let params = {};

      if (searchTitle) {
        params["internal_id"] = searchTitle;
      }

      if (page) {
        params["page"] = page;
      }

      if (pageSize) {
        params["per_page"] = pageSize;
      }

      return params;
    },


    searchInvoices() {
      const params = this.getRequestParams(
        this.searchQuery,
        this.page,
        this.pageSize
      );

      this.loading = true;
      this.$api.searchInvoices(params).then((response) => {
          const { invoices, page, page_count, count } = response.data;
          this.tutorials = invoices;
          this.page = page,
          this.pageCount = page_count
          this.count = count;

          console.log(response.data);
        })
        .catch((e) => {
          console.log(e);
        }).finally(() => {
                        this.loading = false
                    });

    },

    retrieveTutorials() {
      const params = this.getRequestParams(
        this.searchTitle,
        this.page,
        this.pageSize
      );

      this.loading = true;
      this.$api.getInvoices(params).then((response) => {
          const { invoices, page, page_count, count } = response.data;
          this.tutorials = invoices;
          this.page = page,
          this.pageCount = page_count
          this.count = count;

          console.log(response.data);
        })
        .catch((e) => {
          console.log(e);
        }).finally(() => {
                        this.loading = false
                    });

    },

    handlePageChange(value) {
      this.page = value;
      this.retrieveTutorials();
    },

    handlePageSizeChange(value) {
      this.pageSize =value;
      this.page = 1;
      this.retrieveTutorials();
    },
    submitClaimData(){
        const data = {
            
        }
    },
  },
  computed: {
    searchRegExp () {
      return new RegExp(`(.*)${this.search}(.*)`)
    },
    rows() {
      return this.tutorials.length;
    },
  },
  created() {
    this.retrieveTutorials();
  },
}
</script>
<style>
  .no-border-card .card-footer{
    border-top: 0;
  }
</style>
<style scoped>
#axiosForm{  /* Components Root Element ID */
    position: relative;
}
.loader{  /* Loader Div Class */
    position: absolute;
    top:0px;
    right:0px; 
    width:100%;
    height:100%;
    background-color:#eceaea;
    background-image: url(/img/custom/ajax-loader.gif);
    background-size: 50px;
    background-repeat:no-repeat;
    background-position:center;
    z-index:10000000;
    opacity: 0.4;
    filter: alpha(opacity=40);
}
</style>